import { UserData } from './../../models/UserData';
import { TokenService } from './../../shared/token.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry,MatDialog } from '@angular/material';
import { BackLinkService } from '../../shared/back-link.service';
import { HeaderService } from './header.service';
import { UserService } from '../../shared/user.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NAVIGATION_ARRAY, PAGE_BASE_TITLE } from '../../consts/appConsts';
import { ConfirmBackDialogComponent } from '../upload/confirm-back-popup/confirm-back-dialog.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HttpHelpersService } from '../../shared/http-helpers.service';
import { AnalyticsService } from '../../shared/analytics.service';

@Component({
    selector: 'lupa-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
    hideArrow: boolean;
    disableBack: boolean;
    bookName: string;
    albumDetails: any;
    userName: any;
    callbackStack: any[] = [];
    loginOpened: boolean;
    relativeNavigationArray = [];
    showBackNavigation: boolean;
    showBookName = true;
    bookPrice: any;
    showPrice: any;
    isLoginIframe:boolean;
    isPlacingEditor: boolean;
    isDisabledUpSale:boolean = false;
    // token: string = "";
    userData;   

    constructor(
        iconRegistry: MatIconRegistry,
        sanitizer: DomSanitizer,
        private headerService: HeaderService,
        private backLinkService: BackLinkService,
        private userService: UserService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private titleService: Title,
        public dialog: MatDialog,
        private httpHelperService: HttpHelpersService,
        private tokenService : TokenService,
        private analytics : AnalyticsService
    ) {
        // this.token = this.tokenService.token;
        iconRegistry.addSvgIcon(
            'menu',
            sanitizer.bypassSecurityTrustResourceUrl('assets/img/hamburger.svg')
        );
    }

    ngOnInit() {
        this.isDisabledUpSale = false;
        // subscribe for back button logic
        this.backLinkService.link.subscribe(linkObj => {
            setTimeout(() => {
                this.showPrice = linkObj.showPrice;
            });

            if (linkObj.callback) {
                setTimeout(() => {
                    // timeout for updating ui after this.callbackStack.length change
                    this.callbackStack.push(linkObj.callback);
                });
            } else {
                if (this.callbackStack.length) {
                    this.callbackStack.pop();
                }
            }

            this.hideArrow = linkObj.hide;
        });
        this.headerService.cleanStack.subscribe(toClean => {
            if (toClean) {
                this.callbackStack = [];
            }
        });
        // subscribe for book name change
        this.headerService.bookName.subscribe(name => {
            this.bookName = name;
            const pageTitle = `${PAGE_BASE_TITLE} | ${name}`;
            this.titleService.setTitle(pageTitle);
        });
        // subscribe for disable back button
        this.headerService.$disableBack.subscribe(isDisable => {
            this.disableBack = isDisable;
            if (!isDisable) {
                this.hideArrow = false;
            }
        });
        // get album data
        this.headerService.getAlbumData().subscribe(data => {
            if (!data) {
                this.albumDetails = null;
                this.bookPrice = null;
                return;
            }
            if (data.albumName) {
                this.headerService.setBookName(data.albumName);
                this.albumDetails = data;
                this.setBookPrice(this.albumDetails);
            }
        });
        // get user name
        this.headerService.$userName.subscribe(name => {
            this.setUserName(name);
        });

        this.headerService.$toggleBookName.subscribe(toShow => {
            // timeout for updating ui after this.showBookName value change
            setTimeout(() => {
                this.showBookName = toShow;
            });
        });
        // get updated book price
        this.headerService.$bookPrice.subscribe(bookPrice => {
            this.bookPrice = bookPrice;
        });

        // indicate login popup open
        this.userService.$loginOpened.subscribe(isOpen => {
            this.loginOpened = isOpen;
        });
        this.userService.$userData.subscribe(userData => {
            if (userData) {
                this.setUserName(userData.firstName);
                this.setUserData(userData);
            }
        });

        // subscribe for navigation/page change
        this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                const cleanedUrl = e.urlAfterRedirects.split('?')[0];

                if (e.url == "/editor")
                {
                    this.isDisabledUpSale = false;
                }

                // on first navigation change set back navigation array from current Location
                if (!this.relativeNavigationArray.length) {
                    const index = NAVIGATION_ARRAY.indexOf(cleanedUrl);
                    if (index !== -1) {
                        this.relativeNavigationArray = NAVIGATION_ARRAY.slice(index);
                    }
                } else {
                    // check if should be back navigation based on navigation array
                    const index = this.relativeNavigationArray.indexOf(cleanedUrl);
                    if (index > 0) {
                        this.showBackNavigation = true;
                    } else {
                        this.showBackNavigation = false;
                    }
                }
            }
        });

        this.headerService.$isLoginIframe.subscribe((res) =>{
            this.isLoginIframe = res;
        })

        this.headerService.$isPlacingEditor.subscribe((res) =>{
            this.isPlacingEditor = res;
        })
    }
    private setUserName(name: string) {
        if (name!=undefined && name!=null) {
            this.userName = name;
        }
    }


    setUserData(userData:UserData)
    {
        if (userData!=undefined && userData!=null) {
            this.userData = userData;
        }
    }
    // on back click call callback or back navigation
    backClicked(e) {
        e.preventDefault();
        this.headerService.setLoginIframePage(false);
        if (this.callbackStack.length) {
            const callback = this.callbackStack.pop();
            callback();
            this.showPrice = false;
            this.isDisabledUpSale = false;            
        } else {
            this.navigateBack();
        }
    }

    openChatPopup(e) {
        let params = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=370,height=450';
        open("https://account.lupa.co.il/online_chat.aspx", "צ'אט עם נציג", params);
    }

    // navigate back based on back navigation array
    private navigateBack() {
        const currentRoute = this.router.url.split('?')[0];
        const routeIndex = this.relativeNavigationArray.indexOf(currentRoute);
        if (routeIndex === 0) {
        } else if (routeIndex > 0) {
            if(routeIndex == 4 || currentRoute == '/editor'){
                this.openPopup(currentRoute);
            }else{
                const lastRoute = this.relativeNavigationArray[routeIndex - 1];

                this.analytics.sendCustomEvent(this.analytics.createAnalyticObject("go_back","go_back","album",currentRoute, null, this.userService.userData? this.userService.userData.email: null));

                this.router.navigate([lastRoute]);
            }

        }
    }

    private openPopup(currentRoute){
        const dialogRef = this.dialog.open(ConfirmBackDialogComponent, {
            width: "700px",
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const lastRoute = this.relativeNavigationArray[0];
                this.httpHelperService.ajax('get', { method: 'reopenalbum' }).subscribe(()=>{
                    this.analytics.sendCustomEvent(this.analytics.createAnalyticObject("go_back","go_back","album",currentRoute, null, this.userService.userData? this.userService.userData.email: null));
                    if (currentRoute == '/editor')
                    {
                        this.headerService.reopenBook();
                        this.router.navigate(['/create/upload']);
                    }
                    else
                    {
                        this.router.navigate([lastRoute]);
                    }
                });
            } else {
                console.log('cancel proceed');
            }
        });
    }

    goToUpsale() {
        if (this.isDisabledUpSale)
            return;
        this.isDisabledUpSale = true;
        this.headerService.upsaleAction.next(true);

        this.analytics.sendCustomEvent(this.analytics.createAnalyticObject("begin_checkout","begin_checkout","album",null, {'item_name':this.headerService.name,'item_id':this.tokenService.event_token, 'quantity':1}, this.userService.userData? this.userService.userData.email: null));
    }

    login(e) {
        e.preventDefault();
        if (this.loginOpened) {
            return;
        }
        this.userService.openLogin().subscribe(userData => {
            if (userData) {
                this.setUserName(userData.firstName);
                this.setUserData(userData);
            }
        });
    }

    logout(e) {
        e.preventDefault();
        this.userService.openLogout().subscribe(data => {
            if (data && data.status === 'success') {
                this.tokenService.clearTokenStorage();
                location.href = 'https://www.lupa.co.il';
            }
        });
    }

    // toggleSidemenu() {
    //     this.headerService.$toggleSideMenu.next(true);
    // }
    private setBookPrice(albumDetails) {
        this.bookPrice = {
            bookPrice: albumDetails.bookPrice,
            bookPriceOriginal: albumDetails.bookPriceOriginal,
            bookPriceSoft: albumDetails.bookPriceSoft,
            bookPriceSoftOriginal: albumDetails.bookPriceSoftOriginal,
        };
    }

    createBook(){
        if(!this.tokenService.isLoggedIn())
        {
            if (this.tokenService.hasEventToken())
            {
                this.userService.openLogin().subscribe(userData => {
                    if(userData){
                        this.headerService.setUserName(userData.firstName);                        
                        // this.headerService.setUserEmail(userData.email);
                    }        
                });            
            }
            else
            {
                setTimeout(() => {
                    this.router.navigate(['/create'], {
                        // queryParams: { token: this.tokenService.token },
                        replaceUrl: true,
                    });
                });
            }
        }
        else{
            //this.tokenService.clearTokenStorage();
            this.tokenService.event_token = '';
            // this.headerService.$toggleSideMenu.next(false);
            this.headerService.setBookName('');
            setTimeout(() => {
                this.router.navigate(['/create'], {
                    queryParams: { token: this.tokenService.token },
                    replaceUrl: true,
                });
            });
        }
    }
}
